import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { FleetManagerPage } from "pages/FleetManagerPage";

export const FleetManagerRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/fleet-manager">
        <FleetManagerPage />
      </Route>

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/fleet-manager" from="/pages/fleet-manager" />
      <Redirect to="/pages" />
    </Switch>
  );
};
